import { Pipe, PipeTransform } from '@angular/core';
/**
 * PluralPipe returns a simple pluralization key for a number.
 *
 * Maps a number to a pluralization key: 'one', 'few', or 'many'.
 * Primarily used for i18n with Transloco message formatters, which require a plural key to select the correct word form.
 *
 * Example usage with Transloco:
 *```html
 *   @let count = items?.length ?? 0;
 *   {{ 'items_count' | transloco: { count, pluralType: count | plural } }}
 *
 * ```
 * In your Transloco translation file:
 * ```json
 *   "days": "{pluralType, select, one { {{count}} day} many { {{count}} days} few { {{count}} days} other { {{count}} days} }",
 * ```
 */
@Pipe({
    name: 'plural',
    standalone: true,
})
export class PluralPipe implements PipeTransform {
    /**
     * Map number to plural key: 'one' | 'few' | 'many'.
     *
     * @param number Input number.
     * @returns Pluralization key as string.
     */
    transform(number: number): string {
        const tens = number % 100;
        if (tens > 4 && tens < 20) return 'many';
        const rest = number % 10;
        if (rest === 0 || rest > 4) return 'many';
        if (rest === 1) return 'one';
        return 'few';
    }
}
